import { IUser } from '~/modules/users/interfaces/IUser';

/** Admin master = usuário sem revenda atrelada. */
export const isMasterAdmin = (user?: IUser | null): boolean =>
  !!user && !user.resale;
